<template>
  <form-layout>
    <template slot="heading">
      <h5>パスワードがわからない場合</h5>
    </template>
    <password/>
  </form-layout>
</template>

<script>
import Password from '@/components/auth/Password.vue';
import FormLayout from '@/views/FormLayout.vue';

export default {
  name: 'ForgotPassword',
  components: { Password, FormLayout },
};
</script>

<style scoped>

</style>
